module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-chattanooga-in-chattanooga-tennessee-9e1f34f47ee17ae804f168c2c5631edb.png";